import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { useMutationHTTPRequest } from 'api/hooks/useHTTPRequest';
import { getParticipantsSprintsQueryKey } from 'api/utils';
import { logError } from 'lib/sentry/logError';

import { QUERY_KEYS } from 'features/sprint/config';
import { useUserId } from 'features/user/hooks/useUserId';

import { useSprintAnalytics } from '../useSprintAnalytics';

const useSprintStartMutation = () => {
  const userId = useUserId();
  const queryClient = useQueryClient();

  const { request } = useMutationHTTPRequest();
  const { sendSprintStartedEvent } = useSprintAnalytics();

  return useMutation(
    async ({ sprintId }: { sprintId: string }) =>
      await request({
        url: `/api/timeline/sprints/start`,
        body: {
          sprintId,
        },
      }),
    {
      onSuccess: async (_, { sprintId }: { sprintId: string }) => {
        await queryClient.invalidateQueries(
          getParticipantsSprintsQueryKey(userId)
        );
        await queryClient.invalidateQueries(QUERY_KEYS.SPRINT(sprintId));
        await queryClient.invalidateQueries([queryKeys.sprints, userId]);
        await queryClient.invalidateQueries([queryKeys.draftSprints, userId]);

        sendSprintStartedEvent();
      },
      onError: (error) => {
        logError(error);
      },
    }
  );
};

export default useSprintStartMutation;
